import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=8872ae68&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"
import style0 from "./bottom.vue?vue&type=style&index=0&id=8872ae68&prod&scoped=true&lang=scss"
import style1 from "./bottom.vue?vue&type=style&index=1&id=8872ae68&prod&scoped=true&lang=css"
import style2 from "./bottom.vue?vue&type=style&index=2&id=8872ae68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8872ae68",
  null
  
)

export default component.exports